import { useCallback, useEffect, useState } from 'react';
import { getChat, getPreparedClient } from '../AIClients/aiClientData';

// 사례개념화를 쓸 수 있는 면담(종료됨)인지 확인하고 면담 정보를 불러온다.
// status: missing(면담 없음) | checking | notCompleted(면담 미종료) | error | ready
export default function useCompletedSession(saved) {
    const [state, setState] = useState(() => ({ status: saved ? 'checking' : 'missing' }));
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if (!saved) return undefined;
        let active = true;
        setState({ status: 'checking' });
        Promise.all([getPreparedClient(saved.id), getChat(saved.id, saved.token)]).then(([instance, chat]) => {
            if (!active) return;
            if (chat.status !== 'completed') return setState({ status: 'notCompleted' });
            setState({ status: 'ready', instance, startedAt: chat.messages[0]?.createdAt });
        }).catch(failure => {
            if (active) setState({ status: 'error', error: failure.message });
        });
        return () => { active = false; };
    }, [saved, attempt]);

    // 면담 정보 확인을 다시 시도한다.
    const retry = useCallback(() => setAttempt(value => value + 1), []);
    return [state, retry];
}
